<template>
  <div class="promotion-rule-container">
    <van-nav-bar :title="$t('exchange_rule')" left-text="返回" left-arrow>
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
    </van-nav-bar>
    <div class="content" v-html="ruleContent"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleContent: "",
    };
  },
  created() {
    this.getShareRule();
  },
  methods: {
    async getShareRule() {
      const res = await this.$api.getShareRule();
      if (res.code == 200) {
        this.ruleContent = res.data.content;
      }
    },
    navBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  width: 30px;
  height: 15px;
}
.promotion-rule-container {
  .content {
    padding: 20px 15px;
    background: #fff;
    margin-top: 10px;
    font-size: 14px;
    min-height: calc(100vh - 56px);
  }
}
@media (min-width: 640px) {
  /deep/ .van-nav-bar__content {
    height: auto;
  }
  .back {
    width: 30px;
    height: 15px;
  }
  .promotion-rule-container {
    .content {
      padding: 20px 15px;
      background: #fff;
      margin-top: 10px;
      font-size: 14px;
      min-height: calc(100vh - 56px);
    }
  }
}
</style>